import * as api from '../api/queuesearch';
import { makeApiActionCreatorV3 } from '@actions/utils';
import {
  createRequestTypes,
  START,
  SUCCESS,
  ERROR,
} from '@modules/appraisal/actions/global';

const namespace = 'QUEUE';

export const SEARCH_QUEUE = createRequestTypes(`${namespace}/SEARCH_QUEUE`);

export const searchQueue = makeApiActionCreatorV3(
  api.searchQueue,
  SEARCH_QUEUE[START],
  SEARCH_QUEUE[SUCCESS],
  SEARCH_QUEUE[ERROR],
);

export const FETCH_SEARCH_OPTION_NAMES = createRequestTypes(
  `${namespace}/FETCH_SEARCH_OPTION_NAMES`,
);

export const fetchSearchOptionNames = makeApiActionCreatorV3(
  api.fetchSearchOptionNames,
  FETCH_SEARCH_OPTION_NAMES[START],
  FETCH_SEARCH_OPTION_NAMES[SUCCESS],
  FETCH_SEARCH_OPTION_NAMES[ERROR],
);

export const FETCH_SEARCH_OPTION_GROUPS = createRequestTypes(
  `${namespace}/FETCH_SEARCH_OPTION_GROUPS`,
);

export const fetchSearchOptionGroups = makeApiActionCreatorV3(
  api.fetchSearchOptionGroups,
  FETCH_SEARCH_OPTION_GROUPS[START],
  FETCH_SEARCH_OPTION_GROUPS[SUCCESS],
  FETCH_SEARCH_OPTION_GROUPS[ERROR],
);

export const FETCH_SEARCH_OPTION_WORK_ITEM_TYPES = createRequestTypes(
  `${namespace}/FETCH_SEARCH_OPTION_WORK_ITEM_TYPES`,
);

export const fetchSearchOptionWorkItemTypes = makeApiActionCreatorV3(
  api.fetchSearchOptionWorkItemTypes,
  FETCH_SEARCH_OPTION_WORK_ITEM_TYPES[START],
  FETCH_SEARCH_OPTION_WORK_ITEM_TYPES[SUCCESS],
  FETCH_SEARCH_OPTION_WORK_ITEM_TYPES[ERROR],
);
